export enum FeatureKeys {

  //Collection Templates
  CreateTemplate = 'create_template',

  //Organisation
  AddOrgUser = 'add_org_user',

  CreateShare = 'create_share',

  //Document Access
  CreateDocumentAccess = 'create_document_access',
}
